
import EmoticonOutline from 'vue-material-design-icons/EmoticonOutline.vue'

import { emit } from '@nextcloud/event-bus'

import NcActionButton from '@nextcloud/vue/dist/Components/NcActionButton.js'
import NcActionButtonGroup from '@nextcloud/vue/dist/Components/NcActionButtonGroup.js'
import NcActions from '@nextcloud/vue/dist/Components/NcActions.js'

export default {
	name: 'ReactionMenu',

	components: {
		NcActions,
		NcActionButton,
		NcActionButtonGroup,
		EmoticonOutline,
	},

	props: {
		/**
		 * The conversation token
		 */
		token: {
			type: String,
			required: true,
		},

		/**
		 * Signalling participant model
		 */
		localCallParticipantModel: {
			type: Object,
			required: true,
		},

		/**
		 * Supported reactions
		 */
		supportedReactions: {
			type: Array,
			validator: (prop) => prop.every(e => typeof e === 'string'),
			required: true,
		},
	},

	data() {
		return {
			throttleTimer: null,
		}
	},

	computed: {
		container() {
			return this.$store.getters.getMainContainerSelector()
		},

		reactionsInSingleRow() {
			return Math.ceil(this.supportedReactions.length / 2)
		},
	},

	methods: {
		throttledSendReaction(reaction) {
			if (this.throttleTimer) {
				return
			}

			this.sendReaction(reaction)
			this.throttleTimer = setTimeout(() => {
				this.throttleTimer = null
			}, 2000)
		},

		sendReaction(reaction) {
			// send reaction to other participants
			this.localCallParticipantModel.sendReaction(reaction)

			// show reaction to yourself
			emit('send-reaction', {
				model: this.localCallParticipantModel,
				reaction,
			})
		},
	},
}
